import { LocalStorageCache } from '@auth0/auth0-react';
import { CustomError } from './types';

export const getToken = (): string | null => {
    const cache = new LocalStorageCache();
    const keys = cache.allKeys().filter((key) => key.includes('auth0spa'));

    for (const item of keys) {
        const data = cache.get(item);
        if (data && 'body' in data) {
            if (data.body?.access_token) {
                return data.body.access_token;
            }
        }
    }

    return null;
};

export const isApiError = (error: unknown): error is CustomError => {
    return typeof error === 'object' && error !== null &&
        'status' in error && typeof (error as CustomError).status === 'number' &&
        'data' in error && typeof (error as CustomError).data === 'object';
}
